<template>
<v-list dense >
  <communication-watcher
    v-for='message in messages' :key='message.id'
    :message-id='message.id' >
  </communication-watcher>
  <v-list-tile v-if='messages && messages.length === 0' >
    <v-list-tile-avatar >
      <v-progress-circular indeterminate color='amber' width='2' >
      </v-progress-circular>
    </v-list-tile-avatar>
    <v-list-tile-content >
      <v-list-tile-title >
        Waiting for status updates ...
      </v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</v-list>
</template>
<script>
import CommunicationWatcher from './CommunicationWatcher'
export default {
  name: 'BatchIdList',
  components: {CommunicationWatcher},
  props: {
    batchId: { required: true },
    touch: { type: Number, default: 0 },
    waitForSendTimeout: { type: Number, defaut: 10000 }
  },
  computed: {
    messages () {
      return this.$store.getters.getCommsByBatchId(this.batchId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BatchIdList.vue?6b5ebe47